/**
 * @(#)2019/11/14.
 * 封装文件下载功能
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { get, random, jsonpParse } from "./index";

const body = document.querySelector("body");

/**
 * iframe下载方式
 *
 * @param {*} { id, url, style }
 */
const downIframe = function ({ id, url, style }) {
  const html = `<iframe src=${url} id=${id} style=${style}></iframe>`;
  body.insertAdjacentHTML("afterbegin", html);
  return new Promise((resolve, reject) => {
    const iframeDown = setInterval(() => {
      const iframeDom = document.querySelector(`#${id}`);
      const iframeDoc = get(
        iframeDom,
        ["contentDocument", "contentWindow.document"],
        null
      );
      const readyState = get(iframeDoc, "readyState", null);
      if (readyState === "complete") {
        iframeDom.remove();
        clearInterval(iframeDown);
        resolve();
      }
    }, 500);
  });
};

const downA = function ({ id, url, style }) {
  const html = `<a href=${url} id=${id} style=${style}></a>`;
  body.insertAdjacentHTML("afterbegin", html);
  const dom = document.querySelector(`#${id}`);
  dom.addEventListener("click", () => {
    dom.remove();
  });
  dom.click();
};

/**
 * 文件下载函数
 *
 * @param {string} url
 * @param {string} [type='iframe']
 */
export default async function (param) {
  try {
    const { url, type = "iframe" } = param;
    if (url == null) return;
    const style = `height:0;width:0;opacity:0;position:fixed`;
    const id = random();
    const htmlDict = {
      iframe: downIframe,
      a: downA,
    };
    await get(htmlDict, type, () => {})({ id, url, style });
  } catch (error) {
    console.error("文件下载失败了", jsonpParse(JSON.stringify(error)));
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/utils/downFile.js